export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create.vue?vue&type=template&id=4564412f"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/content/links/create.vue?vue&type=template&id=4564412f
// module id = CBW7
// module chunks = 0